import React from 'react';
import { PhoneCallIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const steps = [{
  title: 'Send your list',
  body: 'Type it or just upload a photo of your written list.'
}, {
  title: 'I confirm the total',
  body: 'I check prices, add my service fee, and send you the full cost.'
}, {
  title: 'You pay, I shop',
  body: 'Transfer once, then I handle the market stress for you.'
}, {
  title: 'Delivered next day',
  body: 'Your items arrive at your door, anywhere in Lagos.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="w-full bg-warmgray py-14 sm:py-20" data-id="element-92" data-mp="qiv3j4zxnfyl">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-93" data-mp="cqx11d0q8ibe">
        <Reveal className="text-center md:text-left" data-id="element-94" data-mp="gtjvllos8hca">
          <h2 className="font-display text-3xl uppercase tracking-tight text-purple sm:text-4xl" data-id="element-95" data-mp="gs8p3e3ycvhh">How It Works</h2>
          <p className="mt-2 text-ink/60" data-id="element-96" data-mp="14hureafmfqtp">Four simple steps, from your list to your door.</p>
        </Reveal>

        <ol className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-97" data-mp="19byz4vwpo2vu">
          {steps.map((step, index) => <Reveal as="li" key={step.title} delay={index * 0.08} className="group rounded-card border border-lavender bg-white p-6 text-center shadow-soft transition duration-300 hover:-translate-y-1.5 hover:shadow-lift md:text-left" data-id="element-98" data-mp="2rjlcj664thzh" data-mpi={index}>
              <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-lavender font-display text-lg text-purple transition duration-300 group-hover:bg-purple group-hover:text-white md:mx-0" data-id="element-99" data-mp="2wk8xpb7oj4ls">
                {index + 1}
              </span>
              <h3 className="mt-4 text-lg font-bold text-purple" data-id="element-100" data-mp="36cwtq3qu54jg">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-101" data-mp="3k9k1z2o8nh4o">{step.body}</p>
            </Reveal>)}
        </ol>

        <Reveal className="mt-8 flex flex-col items-center gap-3 rounded-card bg-lavender p-5 text-center sm:flex-row sm:text-left" data-id="element-102" data-mp="3f9fn1h2zaugk">
          <PhoneCallIcon className="h-5 w-5 shrink-0 text-purple" aria-hidden="true" data-id="element-103" data-mp="1ky0uytmhwixn" />
          <p className="text-sm text-purple-deep sm:text-base" data-id="element-104" data-mp="3kzqpr8b60b69">
            If anything is unavailable or a price changes at the market, I call you first before deciding anything.
          </p>
        </Reveal>
      </div>
    </section>;
}